const AllCalendarTypes = ['DATE_RANGE', 'SINGLE_DATE'] as const;

// eslint-disable-next-line prettier/prettier
export type CalendarType = typeof AllCalendarTypes[number];

export { AllCalendarTypes };
